import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

export const getCompanyMembersDataTbleObject = (): DynamicDataTable => {
  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.firstName',
    accessorKey: 'prenom',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.lastName',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const numCinColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.numCin',
    accessorKey: 'numCin',
    variant: DataTableColumnVariant.TEXT,
  };
  const tel1Column: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.tel1',
    accessorKey: 'tel1',
    variant: DataTableColumnVariant.TEXT,
  };

  const tel2Column: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.users.table.tel2',
    accessorKey: 'tel2',
    variant: DataTableColumnVariant.TEXT,
  };

  const isResponsibleColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'settings.companyRequests.users.table.isResponsible.label',
    accessorKey: 'responsable',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `settings.companyRequests.users.table.isResponsible.${value}` };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'success' : 'danger';
      },
    },
  };

  return {
    singular: 'settings.companyInfo.table.singular',
    plural: 'settings.companyInfo.table.plural',
    columns: [firstNameColumn, lastNameColumn, emailColumn, numCinColumn, tel1Column, tel2Column, isResponsibleColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
  };
};
